import CONSTANTS from "const/constants";

import SocialCredential from "./base";

const DEFAULT_SHARE_TYPE = CONSTANTS.INSTAGRAM_OPTIONS.FEED;

const InstagramCredential = SocialCredential.extend({
    parse: function (response) {
        const prevAttrs = this.previousAttributes();
        response = InstagramCredential.__super__.parse.apply(this, arguments);

        response.name = response.instagramDisplayName;
        response.profileImage = response.instagramProfilePictureUrl;
        response.typeLabel = `Instagram`;
        response.platformType = `Instagram user`;
        response.shareType = prevAttrs?.shareType ?? DEFAULT_SHARE_TYPE;

        return response;
    },

    share: function (shareId, data) {
        if (App.Models.user.socialCredentials.getEnabledCredentials()) {
            if (this.getShareType() === CONSTANTS.INSTAGRAM_OPTIONS.REEL) {
                data = {
                    ...data,
                    reel: true
                };
            }
            if (this.getShareType() === CONSTANTS.INSTAGRAM_OPTIONS.STORY) {
                data = {
                    ...data,
                    story: true
                };
            }
        }
        return InstagramCredential.__super__.share.call(this, shareId, data);
    },

    isSocialMedia: function () {
        return true;
    },

    onShareSuccessful: function (response) {
        return InstagramCredential.__super__.onShareSuccessful.call(
            this,
            `shareViaInstagramCount`,
            response
        );
    },

    getShareType: function () {
        return this.get(`shareType`);
    },

    setShareType: function (shareType = DEFAULT_SHARE_TYPE) {
        this.set(`shareType`, shareType);
    }
});

export default InstagramCredential;
